export default function Spacer({ height }) {
  return <div style={{ width: "100%", height: height ?? "5vh" }} />;
}
